export default {
	state: {
		isLoggedIn: false,
		loginTime: null,
		profile: {}
	},

	actions: {
		login(actionContext, credentials) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })

					actionContext.rootGetters["MopaneApi/getInstance"].get(`Service/Login?username=${credentials.username}&password=${encodeURIComponent(credentials.password)}&companyCode=${credentials.companyCode}`)
						.then(response => {
							if (response.data.value == "Invalid login!") {
								actionContext.commit("Loading/hide", null, { root: true })
								actionContext.commit("Toasts/showError", { title: "Login", content: "Incorrect Username and/or Password!" }, { root: true })

								resolve()

								return
							}

							response.data.value.companycode = credentials.companyCode
							response.data.value.alerts = actionContext.rootGetters["MopaneApi/getObjectArrayFromTable"](response.data.value.alerts)

							var columns = "u.email, o.logintimeout, min(ifnull(d_ur.roleid, -1)) as roleid"

							var tableName = "" +
								`@db.${response.data.value.accounttype == 2 ? "user" : "client"} u ` +
								"inner join @db.branch b on case when u.branchid = -1 then 1 else u.branchid end = b.id " +
								"inner join @db.organisation o on b.organisationid = o.id " +
								"left join @db.def_userroles d_ur on u.id = d_ur.userid and d_ur.isdeleted = 0"

							var filter = "" +
								"u.id = " + response.data.value.userid
								+ " group by o.logintimeout"

							actionContext.rootGetters["MopaneApi/getInstance"].get(`Service/GetTableData?columns=${columns}&tableName=${tableName}&filter=${filter}`)
								.then(response2 => {
									var records = actionContext.rootGetters["MopaneApi/getObjectArrayFromTable"](response2.data)

									response.data.value.bucket = process.env.NODE_ENV === actionContext.rootState.MopaneApi.environments.development ? "demo" : credentials.companyCode
									response.data.value.email = records[0].email
									response.data.value.logintimeout = parseFloat(records.length < 1 ? 0.1667 : records[0].logintimeout)
									response.data.value.roleid = parseInt(records.length < 1 ? -1 : records[0].roleid)
									response.data.value.isadmin = response.data.value.roleid == 5
										|| response.data.value.roleid == 6
										|| response.data.value.roleid == 7
										|| response.data.value.roleid == 10
										|| response.data.value.roleid == 11
										|| response.data.value.roleid == 12
										|| response.data.value.roleid == 13
										|| response.data.value.roleid == 14
										|| response.data.value.roleid == 18;

									actionContext.commit("login")
									actionContext.commit("setProfile", response.data.value)
									actionContext.dispatch("Pages/show", "ContentPage", { root: true })
									actionContext.commit("Loading/hide", null, { root: true })

									localStorage.isLoggedIn = true
									localStorage.profile = JSON.stringify(response.data.value)

									resolve()
								})
								.catch(response => {
									actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
									actionContext.commit("Loading/hide", null, { root: true })

									reject(response)
								})
						})
						.catch(response => {
							actionContext.dispatch("logout")
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		},
		googleLogin(actionContext, credentials) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })

					actionContext.rootGetters["MopaneApi/getInstance"].get(`Service/GoogleLogin?token=${credentials.token}&companyCode=${credentials.companyCode}&appversion=mopanewebportal`)
						.then(response => {
							if (response.data == "Invalid login!") {
								actionContext.commit("Loading/hide", null, { root: true })
								actionContext.commit("Toasts/showError", { title: "Login", content: "Incorrect Username and/or Password!" }, { root: true })

								resolve()

								return
							}

							response.data.companycode = credentials.companyCode
							response.data.alerts = actionContext.rootGetters["MopaneApi/getObjectArrayFromTable"](response.data.alerts)

							localStorage.isLoggedIn = true
							localStorage.profile = JSON.stringify(response.data)

							actionContext.commit("login")
							actionContext.commit("setProfile", response.data)
							actionContext.dispatch("Pages/show", "ContentPage", { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							resolve()
						})
						.catch(response => {
							actionContext.dispatch("logout")
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		},
		logout(actionContext) {
			localStorage.isLoggedIn = false
			localStorage.profile = ""
			localStorage.content = ""
			localStorage.serverUrl = ""

			actionContext.commit("Loading/show", null, { root: true })
			actionContext.commit("logout")
			actionContext.dispatch("Intervals/clearAll", null, { root: true })
			actionContext.dispatch("Timeouts/clearAll", null, { root: true })
			actionContext.dispatch("Pages/show", "LoginPage", { root: true })
			actionContext.commit("Loading/hide", null, { root: true })
		},
		forgotPassword(actionContext, credentials) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })
					actionContext.commit("setProfile", { emailaddress: credentials.emailAddress, companycode: credentials.companyCode })

					actionContext.rootGetters["MopaneApi/getInstance"].get(`Service/ForgotPasswordEmail?emailAddress=${credentials.emailAddress}&companyCode=${credentials.companyCode}`)
						.then(response => {
							actionContext.commit("Toasts/showSuccess", { title: "Sent", content: "Email sent!" }, { root: true })
							actionContext.dispatch("Pages/show", "ChangePasswordPage", { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							resolve()
						})
						.catch(response => {
							if (response.response != null && response.response.data == `Table '${credentials.companyCode}.user' doesn't exist`) {
								actionContext.commit("Toasts/showError", { title: "Error", content: "Incorrect email and/or code!" }, { root: true })
							}
							else {
								actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							}

							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		},
		changePassword(actionContext, credentials) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })

					var profile = actionContext.rootState.Profile.profile

					actionContext.rootGetters["MopaneApi/getInstance"].get(`Service/UpdatePassword?emailAddress=${profile.emailaddress}&companyCode=${profile.companycode}&code=${credentials.code}&newPassword=${credentials.newPassword}`)
						.then(response => {
							if (response) {
								actionContext.commit("Toasts/showSuccess", { title: "Changed", content: "Password changed!" }, { root: true })
							}
							else {
								actionContext.commit("Toasts/showError", { title: "Error", content: "Password not changed!" }, { root: true })
							}

							actionContext.dispatch("Pages/show", "LoginPage", { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							resolve()
						})
						.catch(response => {
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		}
	},

	mutations: {
		login(state) {
			state.isLoggedIn = true
			state.loginTime = new Date()
		},
		extendLoginTime(state) {
			state.loginTime = new Date()
		},
		logout(state) {
			state.serverUrl = ""
			state.isLoggedIn = false
			state.loginTime = null
			state.profile = {}
			state.imageUrl = ""
		},
		setProfile(state, profile) {
			if (profile.branchname)
				profile.branchname = (profile.branchname + "").split("<")[0]

			state.profile = profile
		}
	},

	namespaced: true
}